export default __webpack_public_path__ + "static/media/etherscan.61787507.svg";